import { gitProjectSelector } from "src/reducers/project/project";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { addVariable } from "../thunks/addVariable.thunk";

type NewProjectVariable = {
  name: string;
  value: any;
  is_json?: boolean;
  is_sensitive?: boolean;
  visible_build?: boolean;
  visible_runtime?: boolean;
};

export function useAddVariable({
  organizationId,
  projectId
}: {
  organizationId: string;
  projectId: string;
}) {
  const dispatch = useAppDispatch();
  const project = useAppSelector(
    state => gitProjectSelector(state, { organizationId, projectId })!
  );
  return async (data: NewProjectVariable) =>
    await dispatch(addVariable({ organizationId, project, data }));
}
